import { CONNECTION_ONLINE, CONNECTION_OFFLINE } from '../constants';

/**
 * Tells the app when the device loses and regains its connection (LMSNEXT-1325).
 *
 * Without this the reconnect banner only appears once a request has failed, and recovery waits for
 * the retry timer even though the device is back. `navigator.onLine` is a hint -- it says the device
 * has a network, not that our servers can be reached -- so it never resolves a reconnect on its own:
 * it only brings a retry forward and shows the banner sooner.
 */
/**
 * Whether the device reports no network right now. The saga checks this after an attempt, because
 * events that arrive while a request is in flight are not observed by its races.
 */
export function isOffline(target = window) {
  return Boolean(target.navigator) && target.navigator.onLine === false;
}

export default function watchConnectionStatus(dispatch, target = window) {
  const online = () => dispatch({ type: CONNECTION_ONLINE });
  const offline = () => dispatch({ type: CONNECTION_OFFLINE });

  target.addEventListener('online', online);
  target.addEventListener('offline', offline);
  if (target.navigator && target.navigator.onLine === false) offline();

  return () => {
    target.removeEventListener('online', online);
    target.removeEventListener('offline', offline);
  };
}
